import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import About from './views/About'
import Survey from './views/Survey'
import Report from './views/Report'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/apps/marketing-remix',
      name: 'home',
      component: Home
    },
    {
      path: '/apps/marketing-remix/about',
      name: 'about',
      component: About
    },
    {
      path: '/apps/marketing-remix/q/:q',
      name: 'questions',
      component: Survey,
      props: true
    },
    {
      path: '/apps/marketing-remix/results',
      name: 'report',
      component: Report,
      props: true
    },
    {
      path: '*',
      component: Home
    }
  ]
})
